import { css } from 'styled-components'

/**
 * Font helper
 *
 * @param name
 * @param weight
 * @param size
 */
export const font = (name: string, weight = 'normal', size = '') => {
  return css`
    ${props => {
    const fontName = props.theme.font[name]
    const fontFamily = (fontName?.family) || 'sans-serif'
    const fontWeight = (fontName?.[weight]) || 'normal'
    if (process.env.NODE_ENV !== 'production') {
      if (!fontName) {
        // eslint-disable-next-line no-console
        console.error(`Font "${name}" not found`)
      }
      if (fontName && !fontName[weight]) {
        // eslint-disable-next-line no-console
        console.error(`Font weight "${weight}" not found for "${name}"`)
      }
      if (fontName && !fontName.family) {
        // eslint-disable-next-line no-console
        console.error(`Font family not found for "${name}"`)
      }
    }

    return `${fontWeight} ${size} ${fontFamily}`
  }}
  `
}

/**
 * Breakpoint helper
 *
 * @param id
 * @param type
 * @param delta
 * @returns string
 */
const breakpoints: Record<string, number> = {
  lg: 1023,
  sm: 767
}

export const bp = (id: string, type = 'max-width', delta = 0) => {
  /* istanbul ignore next */
  if (!breakpoints[id]) {
    console.warn(`Breakpoint ${id} does not exist.`); // eslint-disable-line
    return () => null
  }

  // @ts-expect-error
  return (...args) => css`
    @media (${type}: ${breakpoints[id] + delta}px) {
      ${
        // @ts-expect-error
        css(...args)
      }
    }
  `
}

// @ts-expect-error
Object.keys(breakpoints).forEach((key: string) => (bp[key] = breakpoints[key]))
